@if (formReady() && cropField(); as cropField) {
  <specific-form-header-section
    [title]="title()"
    [cropField]="cropField"
    [cropYear]="cropYear()"
  ></specific-form-header-section>
  <app-questions-list-form
    [questions]="questions()"
    [formGroup]="formGroup"
    [readOnly]="readOnly()"
    [formStateUpdater]="formStateUpdater()"
    (answersUpdated)="emitAnswersUpdated($event)"
    [cropField]="cropField"
    class="form-container"
  ></app-questions-list-form>
}
